import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Button from 'fuse-ui/components/Button';
import Modal from '../modal/modal';
import DomainsList from './domains-list';

const styles = theme => ( {
    button: {
        margin: theme.spacing.unit,
    },
} );

const VerificationByDomainModal = ( {
    classes, domains, editMode, open, onClose, onSave, onSelection, saveDisabled, senderName } ) => {
    const actions = (
        <>
            <Button
                onClick={onClose}
                variant="text"
                className={classes.button}
                data-automation-id="verification-by-domain-modal-cancel-btn"
            >
                Cancel
            </Button>
            <Button
                onClick={onSave}
                color="primary"
                className={classes.button}
                data-automation-id="verification-by-domain-modal-save-btn"
                disabled={saveDisabled}
            >
                Save
            </Button>
        </>
    );
    return (
        <Modal
            open={open}
            onClose={onClose}
            title={`Edit ${senderName}`}
            dialogContentText="This sender is sending as the following domains. Set the sender status per domain to determine how EFD will categorize the data for processing and reporting."
            subTitle="Set sender status per domain"
            modalActions={actions}
            dataAutomationId="edit-verification-by-domain-modal"
        >
            <DomainsList domainsData={domains} editMode={editMode} onSelection={onSelection} />
        </Modal>
    );

};

VerificationByDomainModal.propTypes = {
    classes: PropTypes.object.isRequired,
    domains: PropTypes.array.isRequired,
    editMode: PropTypes.bool.isRequired,
    onClose: PropTypes.func,
    onSave: PropTypes.func,
    onSelection: PropTypes.func,
    open: PropTypes.bool.isRequired,
    saveDisabled: PropTypes.bool,
    senderName: PropTypes.string.isRequired,
};

VerificationByDomainModal.defaultProps = {
    saveDisabled: false
};

export default withStyles( styles )( VerificationByDomainModal );
